import _ from 'lodash';

function doHasASelectedFacetValue(facetKey, checkedFacets) {
  if (checkedFacets !== null && checkedFacets.length > 0) {
    if (
      _.findIndex(checkedFacets, function (f) {
        return f.startsWith(facetKey);
      }) > -1
    ) {
      return true;
    }
  }
  return false;
}

function setFacets(currentFacets, newFacets, initialSearch, checkedFacets) {
  if (initialSearch) return newFacets;

  for (const key in newFacets) {
    if (
      Object.prototype.hasOwnProperty.call(newFacets, key) &&
      !key.includes('@odata')
    ) {
      // Get the items that are not in the new facet result and set the count to zero
      const difference = _.differenceBy(
        currentFacets[key],
        newFacets[key],
        'value'
      );
      if (difference && difference.length > 0) {
        _.forEach(difference, function (diff) {
          if (!doHasASelectedFacetValue(key, checkedFacets)) diff.count = 0;
        });
      }

      // Get all items that still are in the new facet results and set them to their new count
      const intersect = _.intersectionBy(
        newFacets[key],
        currentFacets[key],
        'value'
      );
      if (intersect && intersect.length > 0) {
        _.forEach(intersect, function (inter) {
          const item = _.find(currentFacets[key], function (x) {
            return x.value === inter.value;
          });
          if (item) item.count = inter.count;
        });
      }
    }
  }
  return currentFacets;
}

function CreateQueryString(searchSettings, currentPage) {
  let result =
    '?t=' +
    searchSettings.searchRequest.top +
    '&o=' +
    searchSettings.searchRequest.orderBy +
    '&p=' +
    currentPage;
  result += '&productoverviewreturnurl=' + window.location.pathname;
  return result;
}

function ConcatFilters(arFilters) {
  if (arFilters) {
    let filters;
    for (let i = 0; i < arFilters.length; i++) {
      if (arFilters[i] && arFilters[i] !== '') {
        if (filters) {
          filters = filters + ' and ' + arFilters[i];
        } else {
          filters = arFilters[i];
        }
      }
    }
    return filters;
  }
  return null;
}

function getHasChanged(item) {
  if (item.value && Array.isArray(item.value)) {
    if (item.value[0] === item.min && item.value[1] === item.max) {
      return false;
    } else {
      return true;
    }
  }
}

function GetFacetFilter(
  items,
  facetSettings,
  complexFacetParents = null,
  complexFacetNames = null
) {
  let filter = '';
  const facets = items.map((item) => {
    const keyValue = item.split('|');
    const facet = facetSettings.find(
      (facetSetting) => facetSetting.key === keyValue[0]
    );

    const facetType =
      !facet && keyValue[0].startsWith('complex') ? 'Complex' : facet.value;

    return { facetKey: keyValue[0], facetValue: keyValue[1], facetType };
  });

  const groupedFacets = _.groupBy(facets, 'facetKey');
  _.forEach(groupedFacets, function (key) {
    let subFilter = '';
    _.forEach(key, function (facet) {
      if (facet.facetType === 'Complex') {
        const complexFacetParentSplitted =
          complexFacetParents[facet.facetKey].split('/');

        subFilter += `${complexFacetParentSplitted[0]}/any(t: t/${
          complexFacetParentSplitted[1]
        } eq '${complexFacetNames[facet.facetKey]}|${facet.facetValue}') or `;
      } else if (facet.facetType === 'Collection') {
        subFilter += `${facet.facetKey}/any(t: t eq '${facet.facetValue}') or `;
      } else if (facet.facetType === 'String') {
        subFilter += `${facet.facetKey} eq '${facet.facetValue}' or `;
      } else {
        subFilter += `${facet.facetKey} eq ${facet.facetValue} or `;
      }
    });

    subFilter = `(${stripLastAndOr(subFilter)})`;
    filter += subFilter + ' and ';
  });

  return stripLastAndOr(filter);
}

function stripLastAndOr(filter) {
  let tmp = filter + '';
  const reAnd = /and$/;
  const reOr = /or$/;

  tmp = tmp.trimEnd();
  tmp = tmp.replace(reAnd, '');
  tmp = tmp.replace(reOr, '');

  return tmp;
}

export {
  doHasASelectedFacetValue,
  setFacets,
  CreateQueryString,
  ConcatFilters,
  getHasChanged,
  GetFacetFilter,
  stripLastAndOr
};
